import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App, sendToAnalytics } from './App';
import reportWebVitals from './reportWebVitals';
import { ShareVisibilityProvider } from './share-visibility-context';
import {AudioProvider} from './audio-context'; // Path to your context file

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


    <ShareVisibilityProvider>
     <AudioProvider>
    <App />
     </AudioProvider>
       </ShareVisibilityProvider>

 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(sendToAnalytics);
